import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
} from 'formik';
import * as yup from 'yup';
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  Alert,
  Button,
  InputGroup,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import PageLoading from '../../components/PageLoading/PageLoading';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import { toNumber } from '../../utils/numbers';

const CHANGE_FACTOR = 25;

class SlumpTableForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  initialValues() {
    const { slumpTableStore } = this.props;
    const steps = slumpTableStore.generateSlumpSteps();
    return {
      code: '',
      description: '',
      steps,
    };
  };

  renderSteps(values, handleChange) {
    const  { slumpTableStore, t } = this.props;
    const { waterUnit } = slumpTableStore;

    return (
      <>
        <Row className="padding-tb-15">
          <Col sm={3} xs={3}>{t('Slump Change')}</Col>
          <Col sm={3} xs={3}>{t('Percent Adjustment Per Step')}</Col>
          <Col sm={3} xs={3}>{t('Amount of Change Per Step')}</Col>
          <Col sm={3} xs={3}>{t('Cumulative Change Per Step')}</Col>
        </Row>
        {values.steps.map((step, index) => (
          <div key={step?.change + index}>
            {step?.change === 0 && (
              <Row key={step.change}>
                <Col sm={12} xs={12}>
                  <p>{t('Mix Default')}</p>
                </Col>
              </Row>
            )}
            {step?.change !== 0 && (
              <Row key={step.change + index}>
                <Col sm={1} xs={1}>
                  <div>
                    {step.change > 0 ? '+' : ''}{step.change}"
                  </div>
                </Col>
                <Col sm={2} xs={2}>
                  <div>
                    {step.change > 0 ? '+' : ''}{step.change * CHANGE_FACTOR} mm
                  </div>
                </Col>
                <Col sm={3} xs={3}>
                  <FormGroup>
                    <InputGroup>
                      <Field
                        name={`steps.${index}.adjustment`}
                        value={step.adjustment !== 0 ? step.adjustment : ''}
                        className="form-control input-sm"
                        onChange={handleChange}
                      />
                      <InputGroup.Addon>
                        %
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col sm={3} xs={3}>
                  <div>
                    {toNumber(step.adjustment/100, 2)} {waterUnit}
                  </div>
                </Col>
                <Col sm={3} xs={3}>
                  <div>
                    {slumpTableStore.calculateCumulativeChange(step.change, values.steps)} {waterUnit}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        ))}
      </>
    );
  };

  render() {
    const  { notifierStore, slumpTableStore, onCancel, t } = this.props;
    const { selectedSlumpTableId } = slumpTableStore;

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{t('Slump Table')}</PortletCaption>
        </PortletTitle>
        <PortletBody>
          <div>
            <Formik
              enableReinitialize
              initialValues={
                !selectedSlumpTableId
                  ? this.initialValues()
                  : slumpTableStore.getSlumpTableById(selectedSlumpTableId)
              }
              validationSchema={yup.object().shape({
                code: yup.string().required('Required!'),
              })}
              onSubmit={(values, actions) => {
                this.setState({
                  error: null,
                });
                let promise;
                if (values.id) {
                  promise = slumpTableStore.updateSlumpTable(values);
                } else {
                  promise = slumpTableStore.addSlumpTable(values);
                }

                promise
                  .then(() => {
                    notifierStore.showSuccess('Saved');
                    actions.resetForm({
                      values: this.initialValues(),
                    });
                    actions.setSubmitting(false);
                    slumpTableStore.setSlumpTableId(null);
                    slumpTableStore.fetchSlumpTables();
                    onCancel();
                  })
                  .catch((e) => {
                    this.setState({
                      error: t('Couldn\'t save', { error: e.message }),
                    });
                    actions.setValues(values);
                    actions.setSubmitting(false);
                  });

              }
              }
            >{({ values,
                errors,
                touched,
                isSubmitting,
                handleChange,
              }) => (
                <Form className={'mix-form'}>
                  {isSubmitting &&
                    <PageLoading/>
                  }
                  <Row>
                    <Col sm={3} xs={6}>
                      <FormGroup className={cx({'has-error': errors.code && touched.code} )}>
                        <ControlLabel>{t('Code')}</ControlLabel>
                        <Field name="code"
                          placeholder="Code"
                          value={values.code || ''}
                          className="form-control input-sm" />
                        <ErrorMessage component="span" name="code" className="help-block" />
                      </FormGroup>
                    </Col>
                    <Col sm={9} xs={6}>
                      <FormGroup className={cx({'has-error': errors.description && touched.description} )}>
                        <ControlLabel>{t('Description')}</ControlLabel>
                        <Field name="description"
                          placeholder="Description"
                          value={values.description || ''}
                          className="form-control input-sm" />
                        <ErrorMessage component="span" name="description" className="help-block" />
                      </FormGroup>
                    </Col>
                  </Row>

                  {this.renderSteps(values, handleChange)}

                  <Row>
                    <Col sm={12} className="text-right">
                      {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
                      <Button onClick={onCancel}>{t('Cancel')}</Button>
                      {' '}
                      <LoadingButton
                        bsStyle="primary"
                        type="submit"
                        label={t('Save')}
                        loadingLabel={t('Save')}
                        isLoading={isSubmitting}
                      />
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
        </PortletBody>
      </Portlet>
    );
  }
}

export default withTranslation()(inject('slumpTableStore', 'notifierStore')(observer(SlumpTableForm)));
